import coverage from '@/data/coverage.json';

/** The attended ports, as plotted on the map. */
export const coveragePoints = coverage.points;
